export default "__VITE_ASSET__f5175d2d__"